import React from "react";

import { Form } from "react-bootstrap";

import { ErrorContainer, InputContainer } from "./inputStyled";

function InputComponent({
  title,
  type,
  withBorder,
  withBoxShadow,
  error,
  iconStart,
  iconEnd,
  register,
  containerClass,
  ...props
}) {
  return (
    <Form.Group>
      {title && <Form.Label htmlFor={props.id || register.name}>{title}</Form.Label>}
      <InputContainer
        $withBorder={withBorder}
        $withBoxShadow={withBoxShadow}
        className={containerClass}
      >
        {iconStart}
        <Form.Control
          type={type}
          id={props.id || register.name}
          {...register}
          {...props}
        />
        {iconEnd}
      </InputContainer>
      {error && <ErrorContainer>{error}</ErrorContainer>}
    </Form.Group>
  );
}

export default InputComponent;
